import { Phone, MapPin, Mail } from "lucide-react";
import { BRAND } from "@/lib/api";
import { Link } from "react-router-dom";
import QwLogo from "@/components/quickwash/QwLogo";

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300" data-testid="site-footer">
      <div className="qw-container py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2.5 mb-3">
            <QwLogo size={42} />
            <div>
              <div className="text-white font-extrabold text-lg" style={{ fontFamily: 'Poppins' }}>Quick Wash</div>
              <div className="text-[10px] font-semibold uppercase tracking-[0.18em] text-emerald-400">Laundry · Drycleaners</div>
            </div>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">Premium Laundry & Dry Cleaning — DSS-19, 2nd Floor, Sec. 4 Extension, Opp. Army Canteen, Near Gym Khana Club, Rohtak-124001, Haryana.</p>
        </div>
        <div>
          <div className="text-white font-semibold mb-3" style={{ fontFamily: 'Poppins' }}>Quick Links</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/book" className="hover:text-white">Book Pickup</Link></li>
            <li><Link to="/track" className="hover:text-white">Track Order</Link></li>
            <li><Link to="/login" className="hover:text-white">Billing Login</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-white font-semibold mb-3" style={{ fontFamily: 'Poppins' }}>Company</div>
          <ul className="space-y-2 text-sm">
            <li><a href="#" className="hover:text-white">Privacy Policy</a></li>
            <li><a href="#" className="hover:text-white">Terms of Service</a></li>
            <li><a href="#" className="hover:text-white">Contact</a></li>
          </ul>
        </div>
        <div>
          <div className="text-white font-semibold mb-3" style={{ fontFamily: 'Poppins' }}>Contact</div>
          <ul className="space-y-2 text-sm">
            <li className="flex gap-2"><Phone size={16} className="mt-0.5"/><a href={`tel:${BRAND.phone}`} className="hover:text-white">{BRAND.phone}</a></li>
            <li className="flex gap-2"><Phone size={16} className="mt-0.5"/><a href={`tel:${BRAND.phone2}`} className="hover:text-white">{BRAND.phone2}</a></li>
            <li className="flex gap-2"><MapPin size={16} className="mt-0.5"/>{BRAND.address}</li>
            <li className="flex gap-2"><Mail size={16} className="mt-0.5"/>hello@quickwash.in</li>
          </ul>
          <div className="mt-4 rounded-lg overflow-hidden border border-slate-800 h-24 bg-slate-800 flex items-center justify-center text-slate-500 text-xs">Google Maps · Rohtak</div>
        </div>
      </div>
      <div className="border-t border-slate-800 py-5 text-center text-xs text-slate-500">© {new Date().getFullYear()} Quick Wash. All rights reserved.</div>
    </footer>
  );
};

export default Footer;
